import clsx from 'clsx';
import React, { memo } from 'react';
import { ProductCategoryId } from '../SectionInformation.constant';

interface Props {
  value?: string;
  title?: string;
  id?: ProductCategoryId;
  children?: React.ReactNode;
}

export const GeneralInfomation = memo(({ value, title, id, children }: Props) => {
  return (
    <div id={id} className="flex flex-col gap-2">
      <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">{title}</h3>
      {children}
      {value && (
        <div
          className={clsx([
            '[&_*]:m-[revert] [&_iframe]:!max-w-full',
            '[&_ul]:[all:revert]',
            '[&_ol]:[all:revert]',
            '[&_p]:[all:revert]',
            '[overflow-wrap:anywhere]',
            '[&_table]:inline-block',
            'jodit-wysiwyg',
          ])}
          // className="[&_iframe]:!max-w-[calc(100vw-24px)] break-words jodit-wysiwyg"
          dangerouslySetInnerHTML={{
            __html: value,
          }}
        />
      )}
      
    </div>
  );
});

GeneralInfomation.displayName = 'GeneralInfomation';
